export enum CloudFileAssociationTab {
    Associate = 1,
    Languages = 2,
    TechnicalInfo = 3
}

export const CLOUD_FILE_ASSOCIATION_DEFAULT_TAB = CloudFileAssociationTab.Associate;
